<a [class]="setClass" (click)="$event.stopPropagation(); clicking();">{{ text }}</a>